export default __webpack_public_path__ + "static/media/onurbelgesi.045be267.jpg";